import React from "react";
import { PAYMENT_GATEWAY_RENDER_DELAY } from "../Payments.constants";

/**
 * This hook returns a boolean value that is initially false, and sets true
 * either on the 1st user interaction (mouse click or a keyboard key click),
 * or after a delay (default 30 seconds) after mount, whichever is earlier
 * @returns shouldLoadPaymentGateways boolean - A boolean value telling
 *          whether to render the payment gateway
 */
const useLazyLoadPaymentGateways = (
    delay: number = PAYMENT_GATEWAY_RENDER_DELAY
) => {
    const [shouldLoadPaymentGateways, setShouldLoadPaymentGateways] =
        React.useState(false);

    React.useEffect(() => {
        // Handler to set state to true on interaction
        const handleUserInteraction = () => {
            if (!shouldLoadPaymentGateways) {
                setShouldLoadPaymentGateways(true);
            }

            // Remove event listeners since we no longer need them
            window.removeEventListener("click", handleUserInteraction);
            window.removeEventListener("keydown", handleUserInteraction);

            // Clear the timeout as we no longer need it
            clearTimeout(timeoutId);
        };

        // Set a timeout to change the state after 30 seconds
        const timeoutId = setTimeout(() => {
            setShouldLoadPaymentGateways(true);
        }, delay);

        // Add event listeners for user interaction
        window.addEventListener("click", handleUserInteraction);
        window.addEventListener("keydown", handleUserInteraction);

        // Cleanup function to remove event listeners and clear timeout
        return () => {
            window.removeEventListener("click", handleUserInteraction);
            window.removeEventListener("keydown", handleUserInteraction);
            clearTimeout(timeoutId);
        };
    }, []);
    return shouldLoadPaymentGateways;
};

export default useLazyLoadPaymentGateways;
